import NextLink from 'next/link';
import Page from '../../components/Page';
import { PATH_AUTH } from '../../routes/paths';
import { VerifyCodeForm } from '../../sections/auth/verify-code';
import AuthLayout from '../../sections/auth/AuthLayout';
import { LinkVoltar } from '../../sections/auth/CamposAuth';

/* ============================================================================
   Verificar codigo - visual novo.

   Segue o mesmo padrao visual de reset-password.jsx (AuthLayout com painel de
   ilustracao), em vez do RootStyle/Container/Typography do MUI que a pagina
   usava antes - fora do padrao das outras telas de auth ja migradas.
   ============================================================================ */

VerifyCode.getLayout = function getLayout(page) {
  return page;
};

export default function VerifyCode() {
  const headerContent = (
    <div className="mb-6">
      <div className="mb-4 flex h-[52px] w-[52px] items-center justify-center rounded-[14px] border border-[rgba(30,136,229,0.15)] bg-gradient-to-br from-[rgba(30,136,229,0.12)] to-[rgba(56,189,248,0.08)]">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden>
          <rect x="2" y="4" width="20" height="16" rx="3" stroke="#1E88E5" strokeWidth="1.5" />
          <path d="M2 7l10 7 10-7" stroke="#1E88E5" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </div>
      <h1 className="m-0 text-[24px] font-extrabold tracking-[-0.4px] text-[#14213D]">Verifique seu e-mail</h1>
      <p className="mb-0 mt-2 text-[12.5px] leading-[1.55] text-[#66768F]">
        Enviamos um código de 6 dígitos para o seu e-mail. Informe o código abaixo para confirmar.
      </p>
    </div>
  );

  const footer = (
    <>
      <LinkVoltar href={PATH_AUTH.login} Componente={NextLink} />
      <p className="mt-3 text-center text-[12.5px] text-[#66768F]">
        Não recebeu o código?{' '}
        <button type="button" onClick={() => {}} className="font-semibold text-[#1E63D5] hover:underline">
          Reenviar código
        </button>
      </p>
    </>
  );

  return (
    <Page title="Verificar código - GPShub">
      <AuthLayout headerContent={headerContent} footer={footer} maxFormWidth={480}>
        <VerifyCodeForm />
      </AuthLayout>
    </Page>
  );
}
